import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import { Header, Nav, HamburgerMenu, BtnSave, BtnEdit, BtnDelete } from './components'

import { 
    loginUserCheck, 
    logoutUser, 
    privilegeFetch, 
    privilegeDeleteById, 
    privilegeFetchDesc, 
    privilegeUpdateDesc 
} from '../redux/actions'

class AdminPrivilege extends Component {

    constructor() {
        super()
        this.state = {
            showInput: false,
            desc: "",
            toggleMenu: false
        }
    }

    componentWillMount() {
        this.props.loginUserCheck()
        this.props.privilegeFetch()
        this.props.privilegeFetchDesc()
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.desc) {
            this.setState({ desc: nextProps.desc })
        }
    }
    
    _onHandleChange(event) {
		this.setState({
	    	[event.target.name]: event.target.value
	    });
    }

    _handleMenu() {
        this.setState({ toggleMenu: !this.state.toggleMenu })
    }

    _handleLogout() {
        this.props.logoutUser()
    }

    _onDeleteItem(id, img) {
        if(window.confirm('Are you sure you want to delete this item?')) {
            let oldImg = decodeURIComponent(img.substring(70,99))
            this.props.privilegeDeleteById(id, oldImg)
        }
    }

    showPrivileges() {
        if(this.props.privileges) {
            return this.props.privileges.map((item, index) => {
                let d = new Date(item.privilege_id)
                const date = d.getDate()+"/"+(d.getMonth()+1)+"/"+d.getFullYear()
                const search = "?id="+item.id+"&img="+item.img+"&title="+item.title+"&point="+item.point
                return (
                    <tr key={++index}>
                        <td>{index}</td>
                        <td className="priv-photo">
                            <img src={item.img} alt="privilege" />
                        </td>
                        <td>{item.title}</td>
                        <td>{item.point}</td>
                        <td>{date}</td>
                        <td>{item.created_by}</td>
                        <td><BtnEdit href="/admin/editprivilege" search={search} /></td>
                        <td><BtnDelete click={() => this._onDeleteItem(item.id, item.img)}/></td>
                    </tr>
                )
            })
        }
    }

    _editDesc() {
        this.setState({
            showInput: !this.state.showInput
        })
    }

    _onSubmitDesc() {
        this.props.privilegeUpdateDesc({ desc: this.state.desc})
    }

    render() {
        if(!this.props.user) return  <div></div> 
        return (
            <div>
                <Header name={this.props.user} logout={() => this._handleLogout()}/>
                <div className="admin-privilege">
                    <Nav active="privilege"/>
                    <div className={(this.state.toggleMenu)? "content moveover": "content"}>
                        <div className="content-inner">
                            <HamburgerMenu onClick={()=>this._handleMenu()} />
                            <div className="title">
                                <h2>สิทธิพิเศษ</h2>
                                <div className="btn-addprivilege">
                                    <Link to="/admin/addprivilege" className="add-privilege">เพิ่มสิทธิพิเศษ</Link>
                                </div>
                            </div>
                            <div className="condition">
                                <div className="text" style={{width: '90%'}} >
                                    <h6>เกณฑ์การนับคะแนน</h6>
                                    <p hidden={this.state.showInput}>{this.state.desc}</p>
                                    {/* <input type="text" name="desc" value={this.state.desc} style={{width: '100%',fontSize: '0.9rem'}} hidden={!this.state.showInput} onChange={(event) => this._onHandleChange(event)} /> */}
                                    <textarea name="desc" hidden={!this.state.showInput} onChange={(event) => this._onHandleChange(event)} value={this.state.desc} style={{width: '100%',fontSize: '0.9rem'}}></textarea>
                                </div>
                                <div className="btn-edit-con">
                                    {(this.state.showInput)?
                                    <BtnSave click={() => this._onSubmitDesc()} />:
                                    <BtnEdit click={() => this._editDesc()} />}
                                </div>
                            </div>
                            <div className="info">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Photo</th>
                                            <th>Title</th>
                                            <th>Point</th>
                                            <th>Created Date</th>
                                            <th>Created By</th>
                                            <th>Edit Privilege</th>
                                            <th>Delete Privilege</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.showPrivileges()}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
 
const mapStateToProps = ({ auth, privilege }) => {
    return { 
        user: auth.user,
        privileges: privilege.privileges,
        desc: privilege.desc
    }
}
 
export default connect(mapStateToProps, { 
    loginUserCheck, logoutUser, privilegeFetch, privilegeDeleteById, privilegeFetchDesc, privilegeUpdateDesc
})(AdminPrivilege);